<template>
  <div>
    <sd-section-title :title="t('srv_title')" :note="t('srv_hint')" style="margin-top:26px" />
    <div class="sd-tool">
      <v-text-field v-model="q" class="sd-search" dense outlined hide-details prepend-inner-icon="mdi-magnify" :placeholder="t('lb_search')" style="min-width:270px" />
      <v-btn-toggle v-model="sector" mandatory dense>
        <v-btn small text value="">{{ t('sec_all') }}</v-btn>
        <v-btn v-for="s in sectors" :key="s.en" small text :value="s.en">{{ isAr ? s.ar : s.en }}</v-btn>
      </v-btn-toggle>
      <span class="grow" />
      <span class="ylab">{{ t('srv_sort') }}</span>
      <v-btn-toggle v-model="sort" mandatory dense>
        <v-btn small text value="part">{{ t('srt_part') }}</v-btn>
        <v-btn small text value="sat">{{ t('srt_sat') }}</v-btn>
        <v-btn small text value="name">{{ t('srt_name') }}</v-btn>
      </v-btn-toggle>
    </div>
    <p class="sd-hint" style="margin:12px 2px 0">{{ t('srv_count', { m: rows.length, n: all.length }) }}</p>
    <div class="svgrid">
      <div v-for="r in rows" :key="r.id" class="svcard" @click="$emit('navigate', { name: 'survey', id: r.id })">
        <div class="top">
          <span class="svbadge" :class="SEC_CLS[r.sectorEn] || 'b3'">{{ isAr ? r.sectorAr : r.sectorEn }}</span>
          <span v-if="r.located" class="locbadge" :title="t('cmp_loc')">📍 <span class="num-ltr">{{ locPct(r) }}%</span></span>
          <span v-if="r.satPct != null" class="svsat" :style="{color: satColorPct(r.satPct), background: `color-mix(in srgb,${satColorPct(r.satPct)} 12%,transparent)`}"><span class="num-ltr">{{ r.satPct }}%</span></span>
        </div>
        <div class="nm">{{ surveyName(r, lang) }}</div>
        <div class="st">
          <span><b>{{ compact(r.participants) }}</b> {{ t('part_u') }}</span>
          <span><b>{{ compact(r.answers || 0) }}</b> {{ t('d_ans_u') }}</span>
          <span><b>{{ r.questions || 0 }}</b> {{ t('srv_qs') }}</span>
        </div>
        <div class="prd"><span class="num-ltr">{{ period(r.from, r.to) }}</span><span style="color:var(--sd-green-600);font-weight:700">{{ isAr ? '←' : '→' }}</span></div>
      </div>
      <div v-if="!rows.length" class="svempty">{{ t('no_data') }}</div>
    </div>
  </div>
</template>
<script>
import { sdMixin } from '../store.js'
import { compact, surveyName, period, satColorPct, SEC_CLS } from '../lib/format.js'
import { locPct } from '../lib/compare.js'
import SdSectionTitle from '../components/SectionTitle.vue'
export default {
  name: 'SdSurveysView',
  components: { SdSectionTitle },
  mixins: [sdMixin],
  data: () => ({ q: '', sector: '', sort: 'part', SEC_CLS }),
  computed: {
    all() { return this.D.leaderboard || [] },
    sectors() { const s = []; const seen = {}; this.all.forEach((r) => { if (r.sectorEn && !seen[r.sectorEn]) { seen[r.sectorEn] = 1; s.push({ en: r.sectorEn, ar: r.sectorAr }) } }); return s },
    rows() {
      const q = this.q.trim().toLowerCase()
      const rows = this.all.filter((r) => (!this.sector || r.sectorEn === this.sector) && (!q || ((r.nameAr || '') + ' ' + (r.nameEn || '')).toLowerCase().includes(q)))
      return rows.slice().sort((a, b) => {
        if (this.sort === 'sat') return ((b.satPct ?? -1) - (a.satPct ?? -1)) || (b.participants - a.participants)
        if (this.sort === 'name') return surveyName(a, this.lang).localeCompare(surveyName(b, this.lang), this.isAr ? 'ar' : 'en')
        return b.participants - a.participants
      })
    },
  },
  methods: { compact, surveyName, period, satColorPct, locPct },
}
</script>
